// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import moment from 'moment'
// @end

// @import components
import {AcademicOfferModuleLayout} from 'app_components/modules/academic/academicOffer'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import ReactSelectService from 'app_services/components/reactSelectService'
import CourseService from 'app_services/campus/academic/courseService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @ADD Component types
interface IAcademicOfferModuleProps {
  nPerPage?: number,
  showPagination?: boolean
  showCategories?: boolean
}
interface IAcademicOfferModuleState {
  courses: Array<any>
  defaultCourses: Array<any>
  status: null | 'loading' | 'error'
  pagination: IPagination
  selectFilter?: TypesSelectFilterAcademicOffer
  filters: object
}

export type TypesSelectFilterAcademicOffer = 'Menor a mayor precio' | 'Mayor a menor precio' | 'Mayor promoción';

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class AcademicOfferModule extends Component<IAcademicOfferModuleProps, IAcademicOfferModuleState> {

  private reactSelectService: ReactSelectService
  private nPerPage: number;
  private showPagination: boolean
  private courseService: CourseService;

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IAcademicOfferModuleProps) {
    super(props)

    this.nPerPage = (this.props.nPerPage) ? this.props.nPerPage : 6
    this.showPagination = (this.props.showPagination) ? this.props.showPagination : false

    this.state = {
      courses: [],
      defaultCourses: [],
      status: 'loading',
      pagination: {
        page: 1,
        perPage: this.nPerPage,
        total: 0,
      },
      selectFilter: undefined,
      filters: {}
    }
    this.reactSelectService = new ReactSelectService()
    this.courseService = new CourseService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.getList()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  getList = async (params?: any) => {

    this.setState({ status: 'loading' })

    let httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      publish: true,
      startPublicationDate: {
        date: 'today',
        direction: 'lte'
      },
      endPublicationDate: {
        date: 'today',
        direction: 'gte'
      },
      sort:{
        field: 'startDate',
        direction: '1'
      }
    }

    if (params) {
      if (params.mode && params.mode !== "") {
        httpParams['mode'] = params.mode
      }
      if (params.price && params.price !== "") {
        httpParams['price'] = params.price
      }
      if (params.search && params.search !== "") {
        httpParams['search'] = params.search
      }
      if (params.city) {
        httpParams['city'] = this.reactSelectService.formatReactSelectResponse(params.city)
      }
      if (params.regional) {
        httpParams['regional'] = this.reactSelectService.formatReactSelectResponse(params.regional)
      }
      if (params.modular) {
        httpParams['modular'] = params.modular
      }
    }



    let courses: Array<any> = []
    let pagination: IPagination = {
      total: 0,
      perPage: this.nPerPage,
      page: 1,
    };

    const coursesResponse = await this.courseService.fetchCourses(httpParams)

    if (coursesResponse && coursesResponse.courses) {
      courses = coursesResponse.courses.reduce((accum: any, element: any) => {
        let startDate = moment.utc(element?.startDate).format('DD/MM/YY')
        let item = {
          key: element?._id,
          elementType: 'course',
          ...element,
          startDate,
        }

        accum.push(item)

        return accum
      }, [])

      pagination = {
        total: coursesResponse?.total_register,
        perPage: coursesResponse?.nPerPage,
        page: coursesResponse?.pageNumber,
      }
    }

    this.setState({
      defaultCourses: courses,
      pagination,
      status: null
    }, () => this.handleClickItemFilter(this.state.selectFilter))
  }

  onClearFilters = () => {
    let params = {page: 1, perPage: this.nPerPage}
    this.setState({ filters: params })
    this.getList(params)
  }

  onFilterChange = (params?: any) => {
    params['perPage'] = this.nPerPage
    params['page'] = 1
    params = {
      ...this.state.filters,
      ...params
    }
    this.setState({ filters: { ...params } })
    this.getList(params)
  }

  onPageChange = async (page: number) => {
    let params = {...this.state.filters, page}
    this.getList(params)
  }

  handleClickItemFilter = (type?: TypesSelectFilterAcademicOffer) => {
    let newCourses: any[] = [...this.state.defaultCourses.filter((a) => !['mooc', 'free'].includes(a.typeCourse))];
    switch(type){
      case 'Menor a mayor precio':
        newCourses = newCourses.sort((a,b) => this.getPrice(a) - this.getPrice(b))
        break;
      case 'Mayor a menor precio':
        newCourses = newCourses.sort((a,b) => this.getPrice(b) - this.getPrice(a))
        break;
      case 'Mayor promoción':
        newCourses = newCourses.sort((a,b) => b.discount - a.discount)
        break;
      default:
        // @INFO Por defecto se organizan con el que este mas próximo a iniciar
        newCourses = newCourses.sort((a,b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime())
        break;
    }
    newCourses = newCourses.concat(...this.state.defaultCourses.filter((a) => ['mooc', 'free'].includes(a.typeCourse)))
    this.setState({courses: newCourses, selectFilter: type});
  }

  handleChangeSearch = (search: string) => {
    this.setState({ filters: {
      ...(this.state.filters ? this.state.filters : {}),
      search,
    } })
  }

  handleOnSearch = () => {
    this.getList({ ...this.state.filters })
  }

  private getPrice = (course: any, withDiscount: boolean = true) => {
    const price = course?.priceCOP
    const discount = course?.discount
    let response = price;
    if (withDiscount && discount) {
      response = response*(1-(discount/100));
    }
    return response;
  }

  render() {
    return(
      <AcademicOfferModuleLayout
        courses={this.state.courses}
        status={this.state.status}
        selectFilter={this.state.selectFilter}
        onFilterChange={this.onFilterChange}
        showPagination={this.showPagination}
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        onClearFilters={this.onClearFilters}
        showCategories={this.props.showCategories}
        handleClickItemFilter={this.handleClickItemFilter}
        filterState={this.state.filters}
        handleChangeSearch={this.handleChangeSearch}
        handleOnSearch={this.handleOnSearch}
        // onHandleCategory={this.onHandleCategory}
      />
    )
  }
}

export default connect(mapStatesToProps)(AcademicOfferModule)
